import { ApplicationState } from '..';

export const getMyCourseActiveOnly = function getMyCourseActiveOnly(state:ApplicationState, takeOnly : number) {
  //console.log(state);
  var list:any = [];
  var itemCount = 0;
  state.mycourse.allIds.some(function (id:string) {
    var c = state.mycourse.byId[id];
    var expiryDate = new Date(c.orderDT);
    expiryDate.setDate(expiryDate.getDate() + c.shelfLifeDays);
    var today = new Date();
    if (expiryDate > today){
      itemCount ++;
      list = [...list ,state.mycourse.byId[id]];
    }
    if (itemCount >= takeOnly)
    {
      return list;
    }
  });

  return list;

  // return state.mycourse.allIds.map(function (id:string) {
  //   return state.mycourse.byId[id];
  // });
};

export const getMyCourse = function getMyCourse(state:ApplicationState) {
    //console.log(state);
    return state.mycourse.allIds.map(function (id:string) {
      return state.mycourse.byId[id];
    });
};

export const getMyCourseById = function getMyCourseById(state:ApplicationState) {
  //console.log(id);
  var result = state.mycourse.byId[state.company.ui.selected];
  return result;
};

export const getMyCourseByCategory = function getMyCourseByCategory(state:ApplicationState) {
    //console.log(state);
     const results:any[] =[];
     if (state.userReducer.ProfessionalCategory){
        state.userReducer.ProfessionalCategory.map(
        (professionalCategoty:string) =>{
          let _category ="";
          if(professionalCategoty === "Accountant")
            _category = "Accountancy";
          else if( professionalCategoty ==="Engineers")
            _category = "Engineering";
          else if( professionalCategoty ==="Contractors")
            _category = "Contractors";
    
          if( _category !=="" &&  state.mycourse.byCategory[_category] !== undefined)
          {
            results.push({Category:_category, Courses:state.mycourse.byCategory[_category].map(function (id:string) {
                return state.mycourse.byId[id];
              }) 
            });
          }
        }
      );
     }

      return results;

    // if(state.userReducer.ProfessionalCategory.length === 0){
    //   return state.mycourse.Category.map(function (Category:any) {
    //     return {
    //       Category, 
    //       Courses:state.mycourse.byCategory[Category].map(function (id:string) {
    //         return state.mycourse.byId[id];
    //       })
    //     }
    //   });
    // }
    // else{
    //   if(state.mycourse.Category.length ===0){
    //     return [];
    //   }
    //   else{

      
    //     const results:any[] =[];
    //      state.userReducer.ProfessionalCategory.map(
    //       (professionalCategoty:string) =>{
    //         let _category ="";
    //         if(professionalCategoty === "Accountant")
    //           _category = "Accountancy";
    //         else if( professionalCategoty ==="Engineers")
    //           _category = "Engineering";
    //         else if( professionalCategoty ==="Contractors")
    //           _category = "Contractors";
      
    //         if( _category !=="" &&  state.mycourse.byCategory[_category] !== undefined)
    //         {
    //           results.push({Category:_category, Courses:state.mycourse.byCategory[_category].map(function (id:string) {
    //               return state.mycourse.byId[id];
    //             }) 
    //           });
    //         }
    //       }
    //     );

    //     return results;
    //   }
    // }
};


//export const getMySelectedCourse = (state: ApplicationState) => state.mycourse.byId[state.mycourse.ui.selected];

// Temporary fixed, event chain issue, Reducer run before Constructor set this.propsthis.props.selectCourse(id)
export const getMySelectedCourse = function getMySelectedCourse(state:ApplicationState, courseId:string) {
  //console.log(courseId);
  var result = state.mycourse.byId[courseId];
  return result;
};